import ja from './locales/ja.json';

export const messages = {
  ja,
};
